import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <button onClick={() => scrollTo('hero')} className="cursor-pointer">
          <img
            src="https://public.readdy.ai/ai/img_res/7239570f-f58b-4ff6-9525-50b66fd9d5f3.png"
            alt="PadelVillas logo"
            className="h-14 w-auto object-contain"
          />
        </button>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'Opportunity', id: 'opportunity' },
            { label: 'Why Us', id: 'why-list' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'FAQ', id: 'faq' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-inter font-medium tracking-wide cursor-pointer whitespace-nowrap transition-colors duration-200 ${
                scrolled ? 'text-[#2C2C2C] hover:text-[#D4845C]' : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/onboarding"
            className="whitespace-nowrap bg-[#D4845C] text-white text-sm font-inter font-medium px-5 py-2.5 rounded-full hover:bg-[#c4734b] transition-colors duration-200 cursor-pointer"
          >
            Register Your Villa
          </Link>
        </div>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i
            className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-[#2C2C2C]' : 'text-white'}`}
          />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {[
            { label: 'Opportunity', id: 'opportunity' },
            { label: 'Why Us', id: 'why-list' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'FAQ', id: 'faq' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-inter font-medium text-[#2C2C2C] hover:text-[#D4845C] cursor-pointer text-left whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/onboarding"
            className="whitespace-nowrap bg-[#D4845C] text-white text-sm font-inter font-medium px-5 py-2.5 rounded-full hover:bg-[#c4734b] transition-colors duration-200 cursor-pointer w-fit"
          >
            Register Your Villa
          </Link>
        </div>
      )}
    </nav>
  );
}
